import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import CheckoutBreadcrumbs from "./CheckoutBreadcrumbs";
import { useCart } from "../context/CartContext";
import { getCheckout, clearCheckout } from "../utils/buyNowStorage";
import api from "../api/axios";

const OrderSuccess = () => {
  const navigate = useNavigate();
  const { clearCart } = useCart();

  const [orders, setOrders] = useState([]);
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const checkout = getCheckout();
    console.log("OrderSuccess checkout:", checkout);
    if (!checkout?.items || !checkout?.addressId || !checkout?.method) {
      navigate("/", { replace: true });
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.username) {
      navigate("/login");
      return;
    }

    api
      .post("/orders/create", {
        username: user.username,
        items: checkout.items,
        addressId: checkout.addressId,
        paymentMethod: checkout.method,
        transactionId: checkout.razorpayPaymentId || undefined,
      })
      .then((res) => {
        setOrders(res.data.orders || [res.data.order]);

        clearCheckout();
        if (checkout.mode === "CART") {
          clearCart();
          localStorage.removeItem("appCart");
        }
      })
      .catch(() => {
        navigate("/", { replace: true });
      });
  }, []);

  if (!orders.length) return null;
  const order = orders[0];
  const isMultiVendor = orders.length > 1;

  return (
    <Box sx={{ maxWidth: 500, mx: "auto" }}>
      <CheckoutBreadcrumbs active={3} />

      <Paper sx={{ p: 3, textAlign: "center" }}>
        <CheckCircleIcon sx={{ fontSize: 80, color: "green" }} />

        <Typography variant="h5" fontWeight={700} mt={1}>
          Order Placed Successfully!
        </Typography>

        {isMultiVendor ? (
          <>
            <Typography mt={1} sx={{ color: "text.secondary", fontSize: 14 }}>
              Group Order ID: <strong>{order.groupId}</strong>
            </Typography>
            <Typography mt={0.5} sx={{ color: "text.secondary", fontSize: 13 }}>
              ({orders.length} sub-orders from different vendors)
            </Typography>
            {orders.map((o, i) => (
              <Typography key={o._id} mt={0.5} sx={{ fontSize: 13 }}>
                Order #{i + 1}: <strong>{o._id}</strong> — ₹{Number(o.total).toLocaleString("en-IN")}
              </Typography>
            ))}
          </>
        ) : (
          <Typography mt={1}>
            Order ID: <strong>{order._id}</strong>
          </Typography>
        )}

        <Typography mt={2}>
          Payment Method: <strong>{order.paymentMethod.toUpperCase()}</strong>
        </Typography>
        <Typography mt={1}>
            Payment Status:{" "}
            <strong>
              {order.payment.status === "PAID"
                ? "Paid"
                : "Pay on Delivery"}
            </strong>
          </Typography>


        <Typography mt={1} sx={{ fontSize: 14 }}>
          Deliver to:
          <br />
          <strong>
            {order.address.addressLine1}
            {order.address.addressLine2
              ? `, ${order.address.addressLine2}`
              : ""}
            <br />
            {order.address.city}, {order.address.state} –{" "}
            {order.address.pincode}
          </strong>
        </Typography>

        <Button
          fullWidth
          sx={{ mt: 3 }}
          variant="contained"
          onClick={() => navigate("/customer/dashboard")}
        >
          View My Orders
        </Button>
      </Paper>
    </Box>
  );
};

export default OrderSuccess;